import React from 'react';
import { TopBanner } from './components/landing/TopBanner';
import { HeroSection } from './components/landing/HeroSection';
import { TestimonialsSection } from './components/landing/TestimonialsSection';
import { PainPointsSection } from './components/landing/PainPointsSection';
import { AudienceSection } from './components/landing/AudienceSection';
import { SystemSection } from './components/landing/SystemSection';
import { TomosSection } from './components/landing/TomosSection';
import { BonusesSection } from './components/landing/BonusesSection';
import { ComparisonSection } from './components/landing/ComparisonSection';
import { OfferSection } from './components/landing/OfferSection';
import { GuaranteeSection } from './components/landing/GuaranteeSection';
import { FAQSection } from './components/landing/FAQSection';
import { FinalCTASection } from './components/landing/FinalCTASection';
import { FooterSection } from './components/landing/FooterSection';
import { StickyMobileCTA } from './components/landing/StickyMobileCTA';
import { PurchaseNotification } from './components/landing/PurchaseNotification';
import { MetaPixel } from './components/landing/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-offwhite font-sans selection:bg-gold-500/30 selection:text-gold-300" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBanner data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <TestimonialsSection data-id="element-5" />
        <PainPointsSection data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <SystemSection data-id="element-8" />
        <TomosSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <ComparisonSection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTASection data-id="element-15" />
      </main>

      <FooterSection data-id="element-16" />

      <StickyMobileCTA data-id="element-17" />

      <PurchaseNotification data-id="element-18" />
    </div>;
}